import BCAlert from '../../BCAlert';
import BCButton from '../../BCButton';
import { BCSpace } from '../../BCSpace';
import Styles from '../assets/styles.scss';
import { IChatNotifications } from '../entities/IChatNotifications';

const ChatNotifications: React.FC<IChatNotifications> = props => {
	if (!props.notifications?.length) return null;

	return (
		<div className={Styles.notifications}>
			{props.notifications.map(notification => {
				return (
					<div key={notification.key}>
						<BCAlert
							message={notification.message}
							description={notification.description}
							type={notification.type}
							action={
								notification.buttons ? (
									<BCSpace direction="vertical">
										{notification.buttons?.map(buttonProps => (
											<div key={buttonProps.id}>
												<BCButton {...buttonProps} />
											</div>
										))}
									</BCSpace>
								) : undefined
							}
							closable
						/>
					</div>
				);
			})}
		</div>
	);
};

export { ChatNotifications };
